import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Alert, Snackbar } from '@mui/material';
import { clearGlobalError } from '../features/errorSlice';

const GlobalError = () => {
  const dispatch = useDispatch();
  const errorMessage = useSelector((state) => state.error.message);

  const handleClose = () => {
    dispatch(clearGlobalError());
  };

  return (
    <Snackbar
      open={Boolean(errorMessage)}
      autoHideDuration={5000}
      onClose={handleClose}
    >
      <Alert onClose={handleClose} severity='error'>
        {errorMessage}
      </Alert>
    </Snackbar>
  );
};

export default GlobalError;
